!(function () {
    "use strict";
    var e,
        t = {
            2483: function (e, t, i) {
                var n = i(4442),
                    o = i(4519);
                class s extends HTMLElement {
                    connectedCallback() {
                        (this.headerEl = document.getElementById("nav-wrapper")),
                            (this.navigationItems = this.querySelectorAll("toggletip-engine")),
                            (this.cartOpenButtons = this.querySelectorAll("button[name='cart-open']")),
                            (this.cartDrawer = document.querySelector("drawer-component")),
                            (this.ux = this.dataset.ux),
                            (this.uxPosition = this.dataset.uxPosition),
                            (this.headerEl.props = {}),
                            // (this.headerEl.props.navMargin = 0),
                            (this.headerEl.props.transformAmount = 0),
                            (this.headerEl.props.lastScroll = window.scrollY),
                            (this.headerEl.props.submenuOpen = !1),
                            (this.headerEl.props.activeMenu = 0),
                            this.resetHeader(),
                            ("off" !== this.uxPosition && "hide" !== this.uxPosition) || this.observeStickySubheader(),
                            "off" !== this.uxPosition && window.addEventListener("scroll", this.handleScroll),
                            this.resetOnResize(),
                            this.handleCartDrawer(),
                            this.enableNavUX();
                    }
                    resetHeader = () => {
                        // this.headerEl.classList.remove("header-visible"),
                        //     this.headerEl.classList.remove("sticky-active"),
                        //     this.headerEl.classList.remove("reached-top"),
                        //     (this.headerEl.style.marginTop = "");
                        //     (document.getElementById("header-spacer").style.paddingTop = "");
                    };
                    handleScroll = () => {
                        (0, n.PU)(this.headerEl, this.uxPosition);
                    };
                    enableNavUX() {
                        "fixed" === this.uxPosition
                            ? this.headerEl.classList.add("sticky")
                            : this.headerEl.classList.remove("sticky"),
                            "click" === this.ux
                                ? (this.navigationItems.forEach((e) => {
                                      e.addEventListener("click", (t) => {
                                          t.stopPropagation(), e.isOpen ? (0, o.G)(!1) : ((0, o.G)(!0, e), e.open());
                                      });
                                  }),
                                  this.closest(".shopify-section").addEventListener("click", () => {
                                      (0, o.G)();
                                  }))
                                : this.navigationItems.forEach((e) => {
                                      const t = e.querySelector(".search-trigger"),
                                          i = e.querySelector(".menu-trigger");
                                      if (t || i)
                                          e.addEventListener("click", (t) => {
                                              t.stopPropagation(),
                                                  e.isOpen ? (0, o.G)(!1) : ((0, o.G)(!0, e), e.open());
                                          });
                                      else {
                                          e.addEventListener("mouseenter", () => {
                                              (0, o.G)(!0, e), e.open();
                                          }),
                                              e.addEventListener("mouseleave", () => {
                                                  e.close();
                                              });
                                          const t = e.querySelector("[data-tooltip]");
                                          t &&
                                              e.handleDropdownEnter &&
                                              e.handleDropdownLeave &&
                                              (t.addEventListener("mouseenter", () => {
                                                  e.handleDropdownEnter();
                                              }),
                                              t.addEventListener("mouseleave", () => {
                                                  e.handleDropdownLeave();
                                              }));
                                      }
                                  }),
                            this.querySelectorAll(".nav").forEach((e) => {
                                (0, n.TS)(e);
                            }),
                            this.querySelectorAll(".nav").forEach((e) => {
                                e.props = {};
                                const t = e.querySelector(".nav__main-menu-link"),
                                    i = t?.parentNode.querySelector(".nav__secondary-menu__item"),
                                    o = this.querySelector(".nav--multilevel .nav__content");
                                if (i && o) {
                                    const e = i.getBoundingClientRect().height;
                                    o.style.height = e + "px";
                                }
                                e.querySelectorAll(".nav__main-menu-link").forEach((t, i) => {
                                    window.matchMedia("(hover: hover)").matches &&
                                        window.matchMedia("(min-width: 1800px)").matches &&
                                        t.addEventListener("mouseover", () => {
                                            (0, n.Uy)(t, e);
                                        }),
                                        t.addEventListener("focus", () => {
                                            (0, n.Uy)(t, e);
                                        }),
                                        t.addEventListener("click", () => {
                                            e.classList.add("nav--secondary-menu-open"), (0, n.Uy)(t, e);
                                            const i = t.getAttribute("data-targetmenu"),
                                                o =
                                                    (e.querySelector(`#${i}`),
                                                    e.querySelector(".nav--mobile__inner-container"));
                                            if (e.classList.contains("nav--mobile")) {
                                                const t = o || e.querySelector(".container");
                                                t &&
                                                    requestAnimationFrame(() => {
                                                        (t.scrollTop = 0),
                                                            (t.scrollLeft = 0),
                                                            "function" == typeof t.scrollTo &&
                                                                t.scrollTo({ top: 0, left: 0, behavior: "auto" });
                                                    });
                                            }
                                        });
                                }),
                                    e.querySelectorAll(".nav__secondary-menu__close").forEach((t) => {
                                        t.addEventListener("click", () => {
                                            (0, n.TS)(e);
                                        });
                                    }),
                                    (0, n.sW)(e, !0);
                            });
                    }
                    observeStickySubheader() {
                        const e = document.querySelector(".sticky-subheader");
                        e &&
                            ((e.props = { isStuck: !1 }),
                            new IntersectionObserver(
                                (e) => {
                                    let [t] = e;
                                    const i = t.intersectionRatio < 1;
                                    t.target.classList.toggle("sticky--stuck", i),
                                        t.target.props.isStuck !== i && (t.target.props.isStuck = i);
                                },
                                { threshold: [1] }
                            ).observe(e));
                    }
                    resetOnResize() {
                        const e = window.matchMedia("(max-width: 1800px)");
                        e.addEventListener("change", () => {
                            (0, o.G)(),
                                e.matches && ((this.headerEl.style.marginTop = 0), (this.headerEl.props.navMargin = 0));
                        });
                    }
                    handleCartDrawer() {
                        this.cartOpenButtons &&
                            this.cartOpenButtons.forEach((e) => {
                                e.addEventListener("click", () => {
                                    (0, o.G)(!0), this.cartDrawer.open();
                                });
                            });
                    }
                    disconnectedCallback() {
                        "off" !== this.uxPosition && window.removeEventListener("scroll", this.handleScroll);
                    }
                }
                window.customElements.get("main-nav") || window.customElements.define("main-nav", s);
            },
            4442: function (e, t, i) {
                i.d(t, {
                    PU: function () {
                        return c;
                    },
                    TS: function () {
                        return n;
                    },
                    Uy: function () {
                        return r;
                    },
                    sW: function () {
                        return s;
                    },
                });
                const n = (e) => {
                        let t;
                        if (
                            (e.classList.remove("nav--secondary-menu-open"),
                            (t = e.classList.contains("nav--mobile")
                                ? e.querySelector(".nav--mobile__inner-container")
                                : e.querySelector(".nav__secondary-menu")),
                            window.matchMedia("(max-width: 1023px)").matches)
                        ) {
                            const i = e.querySelector(".nav__main-menu-link--active");
                            i && i.classList.remove("nav__main-menu-link--active"),
                                e.querySelector(".nav__main-menu-link--active") &&
                                    e
                                        .querySelector(".nav__main-menu-link--active")
                                        .classList.remove("nav__main-menu-link--active"),
                                e.querySelectorAll(".nav__secondary-menu__item--animate-in").forEach((e) => {
                                    e.classList.remove("nav__secondary-menu__item--animate-in"),
                                        e.classList.remove("nav__secondary-menu__item--visible"),
                                        (t.height = "auto");
                                });
                        }
                    },
                    o = (e, t) => {
                        e
                            ? t.classList.add("nav__mobile-dropdown-wrapper--open")
                            : t.classList.remove("nav__mobile-dropdown-wrapper--open");
                    },
                    s = (e) => {
                        e.querySelectorAll(".nav__mobile-dropdown-wrapper").forEach((e) => {
                            const t = e.querySelector(".nav__mobile-accordion-opener");
                            t &&
                                t.addEventListener("click", () => {
                                    t
                                        .closest(".nav--mobile__column")
                                        .querySelectorAll(".nav__mobile-dropdown-wrapper")
                                        .forEach((t) => {
                                            t !== e && t.classList.remove("nav__mobile-dropdown-wrapper--open");
                                        }),
                                        e.classList.contains("nav__mobile-dropdown-wrapper--open")
                                            ? o(!1, e)
                                            : o(!0, e);
                                });
                        });
                    },
                    r = (e, t) => {
                        const i = e.getAttribute("data-targetmenu"),
                            n = t.querySelector(`#${i}`);
                        e.classList.contains("nav__main-menu-link--active") ||
                            (t.querySelectorAll(".nav__main-menu-link:not(.simple)").forEach((e, i) => {
                                ((e, t) => {
                                    e.props.activeMenu = t;
                                })(t, i);
                            }),
                            t.querySelectorAll(".nav__main-menu-link").forEach((e) => {
                                e.classList.remove("nav__main-menu-link--active"), e.setAttribute("aria-expanded", !1);
                            }),
                            e.classList.add("nav__main-menu-link--active"),
                            e.setAttribute("aria-expanded", !0),
                            e.parentNode.querySelector(".nav__secondary-navigation-item-content") &&
                                (window.innerHeight - 140 >
                                e.parentNode.querySelector(".nav__secondary-navigation-item-content").offsetHeight
                                    ? (document.querySelector(".nav--mega_menu .nav__content").style.height =
                                          e.parentNode.querySelector(".nav__secondary-navigation-item-content")
                                              .offsetHeight +
                                          80 +
                                          "px")
                                    : (document.querySelector(".nav--mega_menu .nav__content").style.height =
                                          window.innerHeight - 140 + "px")),
                            t.querySelectorAll(".nav__secondary-menu__item").forEach((e) => {
                                e.classList.remove("nav__secondary-menu__item--animate-in");
                            }),
                            n && n.classList.add("nav__secondary-menu__item--visible"),
                            setTimeout(() => {
                                t.querySelectorAll(".nav__secondary-menu__item").forEach((e) => {
                                    e !== n
                                        ? (e.classList.remove(
                                              "nav__secondary-menu__item--animate-in",
                                              "nav__secondary-menu__item--visible"
                                          ),
                                          e.setAttribute("aria-hidden", "true"))
                                        : (e.classList.add("nav__secondary-menu__item--visible"),
                                          e.setAttribute("aria-hidden", "false"),
                                          requestAnimationFrame(() => {
                                              e.classList.add("nav__secondary-menu__item--animate-in");
                                          }));
                                });
                            }, 300));
                    };
                let a = 0;
                const l = document.querySelector(".sticky-subheader"),
                    c = (e, t) => {
                        const i = "fixed" === t,
                            n = "hide" === t,
                            o = window.scrollY - e.props.lastScroll,
                            s = document.getElementById("header-spacer"),
                            r = document.querySelector(".sticky-priority");
                        if (
                            ((e.props.navMargin += o + a),
                            r && 0 === a && (a = r.offsetHeight),
                            r || (a = 0),
                            n && e.props.navMargin >= e.offsetHeight
                                ? (e.classList.remove("header-visible"),
                                  e.querySelectorAll("toggletip-engine").forEach((e) => e.isOpen && e.close()))
                                : e.classList.add("header-visible"),
                            e.props.submenuOpen
                                ? (e.props.navMargin = 0)
                                : (e.props.navMargin = Math.max(0, Math.min(e.props.navMargin, e.offsetHeight))),
                            n && !e.submenuOpen && (e.style.marginTop = -e.props.navMargin + "px"),
                            l && i)
                        ) {
                            (e.props.transformAmount = -e.props.navMargin + e.offsetHeight),
                                (l.style.top = e.offsetHeight + "px");
                            const t = l.getBoundingClientRect().top === e.getBoundingClientRect().bottom;
                            l.classList.toggle("sticky--stuck", t), (e.style.boxShadow = t ? "none" : "");
                        }
                        l &&
                            n &&
                            (l.props.isStuck
                                ? ((e.props.transformAmount = -e.props.navMargin + e.offsetHeight),
                                  e.classList.add("sticky-active"),
                                  (l.style.marginTop = -e.props.transformAmount + "px"),
                                  (l.style.paddingTop = e.props.transformAmount + "px"))
                                : (e.classList.remove("sticky-active"),
                                  (l.style.marginTop = 0),
                                  (l.style.paddingTop = 0)));
                        const c = Math.max(
                            0,
                            Math.min(window.scrollY, document.body.offsetHeight - window.innerHeight)
                        );
                        (e.props.lastScroll = c),
                            0 === c
                                ? (e.classList.add("reached-top"), (s.style.paddingTop = 0))
                                : (e.classList.remove("reached-top"), (s.style.paddingTop = e.offsetHeight + "px"));
                    };
            },
            1434: function (e, t) {
                const i = "above-overlay",
                    n = new Set();
                t.Z = class {
                    isClosingTimer = null;
                    attachedElements = new Set();
                    constructor() {
                        let e =
                            arguments.length > 0 && void 0 !== arguments[0]
                                ? arguments[0]
                                : document.querySelector("#main-content");
                        (this.container = e),
                            (this.overlay = document.createElement("div")),
                            (this.overlay.innerHTML = "&nbsp;"),
                            this.overlay.classList.add("overlay"),
                            this.overlay.addEventListener("transitionend", (e) => {
                                "opacity" !== e.propertyName ||
                                    this.isOpen ||
                                    (this.attachedElements &&
                                        this.attachedElements.size &&
                                        this.attachedElements.forEach((e) => {
                                            this.detachElement(e);
                                        }),
                                    this.afterClosed && (this.afterClosed(), (this.afterClosed = null)),
                                    this.detachOverlay()),
                                    "opacity" === e.propertyName &&
                                        this.isOpen &&
                                        this.afterOpened &&
                                        (this.afterOpened(), (this.afterOpened = null));
                            }),
                            n.add(this);
                    }
                    attachOverlay() {
                        this.container.appendChild(this.overlay);
                    }
                    detachOverlay() {
                        this.container.removeChild(this.overlay);
                    }
                    async open() {
                        let {
                            attachElements: e,
                            afterOpened: t,
                            beforeOpened: n,
                        } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        await this.attachOverlay(),
                            this.isClosingTimer && (clearTimeout(this.isClosingTimer), (this.isClosingTimer = null)),
                            n && n(),
                            e &&
                                (e.forEach((e) => {
                                    this.attachedElements.add(e);
                                }),
                                this.attachedElements.forEach((e) => {
                                    e.classList.add(i);
                                })),
                            requestAnimationFrame(() => {
                                this.overlay.classList.add("open");
                            }),
                            t && (this.afterOpened = t);
                    }
                    close() {
                        let {
                            delay: e,
                            beforeClosed: t,
                            afterClosed: i,
                        } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        t && t(), (this.afterClosed = i);
                        const n = () => {
                            requestAnimationFrame(() => {
                                this.overlay.classList.remove("open");
                            });
                        };
                        e ? (this.isClosingTimer = setTimeout(n, e)) : n();
                    }
                    detachElement(e) {
                        this.attachedElements.has(e) &&
                            e.classList.contains(i) &&
                            (e.classList.remove(i), this.attachedElements.delete(e));
                    }
                    get isOpen() {
                        return this.overlay.classList.contains("open");
                    }
                    onClick() {
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : () => {};
                        e && this.overlay.addEventListener("click", e);
                    }
                    removeOnClick() {
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : () => {};
                        e && this.overlay.removeEventListener("click", e);
                    }
                    onHover() {
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : () => {};
                        e &&
                            this.overlay.addEventListener("mouseover", (t) => {
                                this.isOpen && e(t);
                            });
                    }
                };
            },
            4519: function (e, t, i) {
                i.d(t, {
                    G: function () {
                        return c;
                    },
                });
                var n = i(1434),
                    o = i(6072),
                    s = i(3397);
                const r = new n.Z();
                class a extends HTMLElement {
                    constructor() {
                        super(),
                            (this.headerEl = document.getElementById("nav-wrapper")),
                            (this.headerUXPosition = document
                                .querySelector(".header")
                                .getAttribute("data-ux-position")),
                            (this.predictiveSearch = this.querySelector("predictive-search")),
                            (this.mobileView = this.dataset.mobileView ? this.dataset.mobileView : "floating"),
                            (this.isWithinHeader = this.closest("#nav-wrapper")),
                            (this.overlayAttachingElements = this.isWithinHeader
                                ? [this.headerEl]
                                : [this.closest(".shopify-section"), this.headerEl]),
                            (this.navigationItemTrigger = this.querySelector("[data-tooltip-trigger]")),
                            (this.navigationItemPopover = this.querySelector("[data-tooltip]")),
                            (this.arrowElement = this.querySelector("#arrow")),
                            (this.spacing = 16),
                            (this.isSearchTooltip = !!this.predictiveSearch),
                            this.navigationItemPopover.addEventListener("click", (e) => {
                                e.stopPropagation();
                            }),
                            (this.closeOnScroll = this.closeOnScroll.bind(this)),
                            this.addEventListener("click", (e) => {
                                e.stopPropagation();
                            });
                        const e = this.closest(".shopify-section");
                        e &&
                            e.addEventListener("click", (t) => {
                                t.target.closest("toggletip-engine") || l(e);
                            }),
                            (this.handleResize = (0, o.Ds)(() => {
                                this.isOpen &&
                                    (window.matchMedia("(max-width: 1023px)").matches &&
                                    "fullscreen" === this.mobileView
                                        ? this.updateMobileFullscreen()
                                        : this.update());
                            }, 100)),
                            (this.container = this.closest(".shopify-section")?.querySelector(".section__wrapper"));
                    }
                    update() {
                        const e = this.navigationItemTrigger,
                            t = this.navigationItemPopover,
                            i = this.container?.getBoundingClientRect(),
                            n = this.container?.classList.contains("container--full_bleed"),
                            o = window.getComputedStyle(this.container),
                            r = parseInt(o.paddingLeft),
                            a = parseInt(o.paddingRight),
                            l = [
                                (0, s.cv)(() => (window.matchMedia("(max-width: 1023px)").matches ? 16 : 8)),
                                (0, s.RR)({
                                    boundary: "viewport",
                                    padding: {
                                        left: n ? r : i?.left || 0,
                                        right: n ? a : window.innerWidth - (i?.right || window.innerWidth),
                                    },
                                }),
                                (0, s.uY)({
                                    boundary: "viewport",
                                    padding: {
                                        left: n ? r : i?.left || 0,
                                        right: n ? a : window.innerWidth - (i?.right || window.innerWidth),
                                    },
                                    alignment: "start",
                                }),
                                (0, s.x7)({ element: this.arrowElement }),
                                (0, s.dp)({
                                    apply(e) {
                                        let { availableWidth: o, availableHeight: s } = e;
                                        const l = n
                                            ? window.innerWidth - (r + a)
                                            : i?.width > 1600
                                              ? 1600
                                              : i?.width || Math.min(window.innerWidth, 1600);
                                        Object.assign(t.style, {
                                            maxWidth: `${l}px`,
                                            maxHeight: t.classList.contains("tooltip--mobile") ? "" : "640px",
                                            height: t.classList.contains("tooltip--mobile") ? `${s}px` : "",
                                        });
                                    },
                                    padding: this.spacing,
                                    boundary: "viewport",
                                }),
                            ];
                        (0, s.oo)(e, t, { placement: "bottom-start", middleware: l, boundary: "viewport" }).then(
                            (e) => {
                                let { x: i, y: n, placement: o, middlewareData: s } = e,
                                    r = n;
                                if (
                                    (o.startsWith("top") && this.isSearchTooltip && (r = n - 60),
                                    Object.assign(t.style, { left: `${i}px`, top: `${r}px` }),
                                    !this.arrowElement)
                                )
                                    return;
                                const { x: a, y: l } = s.arrow,
                                    c = { top: "bottom", right: "left", bottom: "top", left: "right" }[o.split("-")[0]];
                                Object.assign(this.arrowElement.style, {
                                    left: null != a ? `${a}px` : "",
                                    top: null != l ? `${l}px` : "",
                                    right: "",
                                    bottom: "",
                                    [c]: `-${this.spacing}px`,
                                });
                            }
                        );
                    }
                    updateMobileFullscreen() {
                        Object.assign(this.navigationItemPopover.style, {
                            left: `${this.spacing}px`,
                            top: `${this.spacing}px`,
                            bottom: `${this.spacing}px`,
                        });
                    }
                    scrollIntoView(e) {
                        if ("off" !== this.headerUXPosition) {
                            const t = e.getBoundingClientRect();
                            window.scrollTo(t.left, t.top + window.scrollY - this.headerEl.clientHeight);
                        } else e.scrollIntoView();
                    }
                    open() {
                        const e = window.matchMedia("(max-width: 1023px)").matches;
                        this.isOpen ||
                            (e
                                ? ("fullscreen" === this.mobileView
                                      ? ("off" !== this.headerUXPosition &&
                                            ((this.headerEl.style.marginTop = `-${this.headerEl.clientHeight}px`),
                                            (this.headerEl.props.lastScroll = window.scrollY),
                                            (this.headerEl.props.navMargin = this.headerEl.clientHeight)),
                                        this.navigationItemPopover.removeAttribute("style"),
                                        this.updateMobileFullscreen(),
                                        r.open({ attachElements: [this.closest(".shopify-section")] }))
                                      : (this.navigationItemPopover.removeAttribute("style"),
                                        this.update(),
                                        r.open({ attachElements: [this.closest(".shopify-section"), this.headerEl] })),
                                  (0, o.hO)(!0))
                                : (this.navigationItemPopover.removeAttribute("style"),
                                  this.update(),
                                  r.open({ attachElements: this.overlayAttachingElements }),
                                  this.isWithinHeader ||
                                      setTimeout(() => {
                                          this.scrollIntoView(this.navigationItemPopover);
                                      }, 100),
                                  document.addEventListener("scroll", this.closeOnScroll)),
                            this.navigationItemTrigger.setAttribute("open", "true"),
                            r.onClick((e) => {
                                this.close();
                            }),
                            this.predictiveSearch && this.predictiveSearch.open(),
                            (0, o.gp)(!0, this.close.bind(this)),
                            window.addEventListener("resize", this.handleResize));
                    }
                    close() {
                        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        this.isOpen &&
                            (this.navigationItemTrigger.removeAttribute("open"),
                            Object.assign(this.navigationItemPopover.style, {
                                top: "-9999px",
                                left: "-9999px",
                                visibility: "hidden",
                                opacity: "0",
                                zIndex: "-1",
                            }),
                            e &&
                                this.overlayAttachingElements.forEach((e) => {
                                    r.detachElement(e);
                                }),
                            r.close(),
                            this.predictiveSearch && this.predictiveSearch.close(),
                            (0, o.gp)(!1, this.close.bind(this)),
                            window.matchMedia("(max-width: 1023px)").matches
                                ? ((0, o.hO)(!1), (this.headerEl.style.marginTop = "0px"))
                                : document.removeEventListener("scroll", this.closeOnScroll),
                            window.removeEventListener("resize", this.handleResize));
                    }
                    closeOnScroll() {
                        !(0, o.v4)(this) && this.isOpen && this.close();
                    }
                    get isOpen() {
                        return "true" === this.navigationItemTrigger.getAttribute("open") && r.isOpen;
                    }
                    disconnectedCallback() {
                        window.removeEventListener("resize", this.handleResize), this.isOpen && this.close(!0);
                    }
                }
                window.customElements.get("toggletip-engine") || window.customElements.define("toggletip-engine", a);
                const l = (e) => {
                        e.querySelectorAll("toggletip-engine").forEach((e) => e.isOpen && e.close());
                    },
                    c = function () {
                        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                        const i = document.querySelectorAll("toggletip-engine");
                        t
                            ? i.forEach((i) => i !== t && i.isOpen && i.close(e))
                            : i.forEach((t) => t.isOpen && t.close(e));
                    };
            },
            6072: function (e, t, i) {
                i.d(t, {
                    Ds: function () {
                        return a;
                    },
                    gp: function () {
                        return r;
                    },
                    hO: function () {
                        return n;
                    },
                    v4: function () {
                        return l;
                    },
                });
                const n = function () {
                    const t = window.innerWidth - document.body.offsetWidth;
                    const i = document.getElementById("nav-wrapper");
                    let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    e
                        ? (document.body.classList.add("no-scroll"),
                          (document.body.style.paddingRight = t + "px"),
                          (i.style.paddingRight = t + "px"))
                        : (document.body.classList.remove("no-scroll"),
                          (document.body.style.paddingRight = "0px"),
                          (i.style.paddingRight = "0px"));
                };
                let o = () => {};
                const s = (e) => {
                        "Escape" === e.key && (o(), window.removeEventListener("keydown", s));
                    },
                    r = function () {
                        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                            t = arguments.length > 1 ? arguments[1] : void 0;
                        t && (o = t),
                            e && window.addEventListener("keydown", s),
                            e || window.removeEventListener("keydown", s);
                    };
                function a(e, t) {
                    const i = this;
                    let n;
                    return function () {
                        for (var o = arguments.length, s = new Array(o), r = 0; r < o; r++) s[r] = arguments[r];
                        clearTimeout(n),
                            (n = setTimeout(function () {
                                return e.apply(i, s);
                            }, t));
                    };
                }
                document.querySelectorAll(".local-scroll").forEach((e) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault(), e.stopPropagation();
                        const t = e.target.getAttribute("href");
                        !(function (e) {
                            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                            const i = document.getElementById("nav-wrapper"),
                                n = document.querySelector(".header").getAttribute("data-ux-position"),
                                o = e.getBoundingClientRect().top;
                            window.scrollTo({
                                top:
                                    "off" !== n
                                        ? o + window.scrollY - t + parseFloat(i.style.marginTop)
                                        : o + window.scrollY - t,
                                behavior: "smooth",
                            });
                        })(document.querySelector(t));
                    });
                });
                const l = function (e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 120;
                    const i = e.getBoundingClientRect(),
                        n = document.documentElement;
                    return (
                        i.top >= -t &&
                        i.left >= -t &&
                        i.bottom <= (window.innerHeight || n.clientHeight) + t &&
                        i.right <= (window.innerWidth || n.clientWidth) + t
                    );
                };
            },
        },
        i = {};
    function n(e) {
        var o = i[e];
        if (void 0 !== o) return o.exports;
        var s = (i[e] = { exports: {} });
        return t[e](s, s.exports, n), s.exports;
    }
    (n.m = t),
        (e = []),
        (n.O = function (t, i, o, s) {
            if (!i) {
                var r = 1 / 0;
                for (d = 0; d < e.length; d++) {
                    (i = e[d][0]), (o = e[d][1]), (s = e[d][2]);
                    for (var a = !0, l = 0; l < i.length; l++)
                        (!1 & s || r >= s) &&
                        Object.keys(n.O).every(function (e) {
                            return n.O[e](i[l]);
                        })
                            ? i.splice(l--, 1)
                            : ((a = !1), s < r && (r = s));
                    if (a) {
                        e.splice(d--, 1);
                        var c = o();
                        void 0 !== c && (t = c);
                    }
                }
                return t;
            }
            s = s || 0;
            for (var d = e.length; d > 0 && e[d - 1][2] > s; d--) e[d] = e[d - 1];
            e[d] = [i, o, s];
        }),
        (n.d = function (e, t) {
            for (var i in t) n.o(t, i) && !n.o(e, i) && Object.defineProperty(e, i, { enumerable: !0, get: t[i] });
        }),
        (n.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (n.j = 6899),
        (function () {
            var e = { 6899: 0, 68: 0, 8973: 0, 5534: 0, 3625: 0 };
            n.O.j = function (t) {
                return 0 === e[t];
            };
            var t = function (t, i) {
                    var o,
                        s,
                        r = i[0],
                        a = i[1],
                        l = i[2],
                        c = 0;
                    if (
                        r.some(function (t) {
                            return 0 !== e[t];
                        })
                    ) {
                        for (o in a) n.o(a, o) && (n.m[o] = a[o]);
                        if (l) var d = l(n);
                    }
                    for (t && t(i); c < r.length; c++) (s = r[c]), n.o(e, s) && e[s] && e[s][0](), (e[s] = 0);
                    return n.O(d);
                },
                i = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
            i.forEach(t.bind(null, 0)), (i.push = t.bind(null, i.push.bind(i)));
        })();
    var o = n.O(void 0, [1216], function () {
        return n(2483);
    });
    o = n.O(o);
})();
